import type { WithdrawalAccount } from '../state/Radom'

export interface BankFundingAsset { network: string, token?: string | null }
export interface BankWithdrawalAvailability { usdAssets: BankFundingAsset[], eurAssets: BankFundingAsset[] }

export const hasBankWithdrawals = (availability?: BankWithdrawalAvailability): boolean =>
  !!(availability?.usdAssets.length || availability?.eurAssets.length)

export const bankWithdrawalAssets = (availability: BankWithdrawalAvailability | undefined, currency: 'USD' | 'EUR'): BankFundingAsset[] =>
  (currency === 'USD' ? availability?.usdAssets : availability?.eurAssets) ?? []

export const matchesBankFundingAsset = (asset: BankFundingAsset, supported: BankFundingAsset[]): boolean =>
  supported.some(method => method.network === asset.network && !!method.token && !!asset.token &&
    (asset.network === 'Solana' ? method.token === asset.token : method.token.toLowerCase() === asset.token.toLowerCase()))

export const bankWithdrawalProvider = (account: WithdrawalAccount, availability: BankWithdrawalAvailability | undefined, ivyEnabled: boolean): 'bastion' | 'ivy' | 'unavailable' => {
  const fiat = account.accountDetails.Fiat?.accountType
  if (fiat?.us) return bankWithdrawalAssets(availability, 'USD').length ? 'bastion' : 'unavailable'
  if (fiat?.iban) {
    if (bankWithdrawalAssets(availability, 'EUR').length) return 'bastion'
    return ivyEnabled ? 'ivy' : 'unavailable'
  }
  return 'unavailable'
}
